import { useLocation } from "react-router-dom";
import type { Person } from "@/services/api";
import type { MaybeType } from "@/shared/types";

export const getAllNameCombinations = ({
  firstName,
  middleName,
  lastName,
}: {
  firstName: string;
  middleName: string;
  lastName: string;
}) => {
  const names = [firstName, middleName, lastName];
  const result: string[] = [];

  const generateCombinations = (arr: string[], currentCombination: string) => {
    if (arr.length === 0) {
      result.push(currentCombination.trim());
      return;
    }

    for (let i = 0; i < arr.length; i++) {
      const nextArr = arr.slice(0, i).concat(arr.slice(i + 1));
      generateCombinations(nextArr, currentCombination + " " + arr[i]);
    }
  };

  generateCombinations(names, "");

  return result;
};

export const isPersonSelected = () => {
  const location = useLocation();

  return !!location.pathname.split("/")[2];
};

export const getSwipedPersonName = (
  filteredPersons: Person[],
  swipedPerson?: MaybeType<string>,
) => {
  const swipedRecord = filteredPersons.find((person) => person.id === swipedPerson);
  return {
    firstName: swipedRecord?.firstName,
    lastName: swipedRecord?.lastName,
  };
};
